import { DatePipe } from '@angular/common';
import { Paginazione } from '../../shared/models/paginazione';
export class Filtri_Valutazioni extends Paginazione {
  datepipe? = new DatePipe('it-it');
  inizio?: string;
  fine?: string;
  periodo?:boolean = true;
  cliente?: string;
  orderByData?: 'asc'|'desc'|null;
  constructor(inizio?, fine?, orderByData? ,cliente?,page?, size?) {
    super(page || 1, size || 100);
    this.cliente = cliente;
    this.orderByData = orderByData;
    const today = new Date();
    const inizioMese = new Date(today.getFullYear(), today.getMonth(), 1);
    const fineMese = new Date(today.getFullYear(), today.getMonth() + 1, 0) ;
    this.inizio = this.datepipe.transform(inizio || inizioMese,'yyyy-MM-dd');
    this.fine = this.datepipe.transform(fine || fineMese, 'yyyy-MM-dd');
  }
}
